import React from 'react';
import { useNavigate } from 'react-router-dom';

const Home = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-black flex h-screen w-full flex-col items-center justify-center">
      <div className="flex flex-col items-center justify-center gap-8">
        <div className="flex items-center gap-4">
          <img
            src="/assets/images/logo-desktop.png"
            alt="Clínica Cayetano Heredia"
            className="h-20 w-auto object-contain"
          />
          <span className="text-primary text-5xl font-bold">PACS</span>
        </div>

        <p className="text-gray-400 text-center text-sm max-w-md">
          Sistema de Archivo y Comunicación de Imágenes
        </p>

        <footer className="mt-8 flex items-center justify-center gap-4">
          <span className="text-primary text-xs">2026 Clínica Cayetano Heredia</span>
          <span className="text-gray-600">|</span>
          <a
            href="https://davix.ai/"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-primary text-xs text-gray-400 transition-colors duration-200"
          >
            powered by Davix
          </a>
        </footer>
      </div>
    </div>
  );
};

export default Home;
